<template>
  <b-notification :has-icon="true" icon="file" :closable="false">
    {{ $t('compCarbonFormsVehiclesHelpFileFormat.info-1') }}
    <a class="link" href="/static/carbon/vehiclesTemplate.tsv" download>{{
      $t('compCarbonFormsVehiclesHelpFileFormat.info-2a')
    }}</a>
    {{ $t('compCarbonFormsVehiclesHelpFileFormat.info-2b') }}
    <a class="link" href="/static/carbon/vehiclesTemplate.csv" download>{{
      $t('compCarbonFormsVehiclesHelpFileFormat.info-2c')
    }}</a
    >).
    {{ $t('compCarbonFormsVehiclesHelpFileFormat.info-3') }}
    <br /><br />
    <ul style="list-style-type: square; margin-left: 25px">
      <li v-html="$t('compCarbonFormsVehiclesHelpFileFormat.file.col1')"></li>
      <li v-html="$t('compCarbonFormsVehiclesHelpFileFormat.file.col2')"></li>
      <li v-html="$t('compCarbonFormsVehiclesHelpFileFormat.file.col3')"></li>
      <li v-html="$t('compCarbonFormsVehiclesHelpFileFormat.file.col4')"></li>
      <li v-html="$t('compCarbonFormsVehiclesHelpFileFormat.file.col5')"></li>
    </ul>
  </b-notification>
</template>

<script>
export default {
  name: 'HelpFileFormat'
}
</script>
